export default "__VITE_ASSET__Bkp7nJFm__"